import React from "react";
import { Link } from "react-router-dom";
import $ from "jquery";

class SideMenu extends React.Component {

    constructor(props) {
    super(props);
    this.state = { 
    background: "",
    color: "",
    display: ""
    };
  }

  changeBackground = () => {
    this.setState({ background: "#28282e",
    color: "#1FB5AD",
    display: "block" });
  };


    componentDidMount() {

        $(document).ready(function () {
            $('.sidebar-toggle-box .fa-bars').click(function (e) {

                $('#sidebar').toggleClass('hide-left-bar');
                $('#main-content').toggleClass('merge-left');
                e.stopPropagation();
                if ($('#container').hasClass('open-right-panel')) {
                    $('#container').removeClass('open-right-panel')
                }
            });
    
        })
    }

    render() {

        return (
            <div>
                                    <aside>
                        <div id="sidebar" className="nav-collapse">
                            <div className="leftside-navigation">
                                <ul className="sidebar-menu" id="nav-accordion">
                                    <li>
                                            <Link
                                                to={{
                                                    pathname:"/admin/challenges"
                                                }}
                                                onClick={() => this.changeBackground}
                                                >
                                                 <i className="fa fa-dashboard"></i>
                                            <span>Challenges</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                                to={{
                                                    pathname:"/admin/quizzes"
                                                }}
                                                onClick={() => this.changeBackground}
                                                >
                                            <i className="fa fa-laptop"></i>
                                            <span>Quizzes</span>
                                        </Link>
                                    </li>
                                    <li>
                                       <Link
                                                to={{
                                                    pathname:"/admin/students"
                                                }}
                                                onClick={() => this.changeBackground}
                                                >
                                            <i className="fa fa-book"></i>
                                            <span>Students</span>
                                        </Link>
                                    </li>
                                    <li>
                                       <Link
                                                to={{
                                                    pathname:"/admin/result"
                                                }}
                                                onClick={() => this.changeBackground}
                                                >
                                            <i className="fa fa-bullhorn"></i>
                                            <span>Result</span>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </aside>
            </div>
        );
    }
}



export default SideMenu;
